import Loadable from "app/components/Loadable";
import { lazy } from "react";

const FarmManagementConditionList = Loadable(lazy(() => import("./FarmManagementConditionList")));
const FarmManagementConditionForm = Loadable(lazy(() => import("./FarmManagementConditionForm")));

const farmManagementConditionRoutes = [
  {
    path: "/FarmManagementCondition/FarmManagementConditionList",
    element: <FarmManagementConditionList />,
  },
  {
    path: "/FarmManagementCondition/FarmManagementConditionForm",
    element: <FarmManagementConditionForm />,
  },
  {
    path: "/FarmManagementCondition/FarmManagementConditionForm/:farmManagementConditionId",
    element: <FarmManagementConditionForm />,
  },
];

export default farmManagementConditionRoutes;
